// extracted by mini-css-extract-plugin
export default {"content":"oI-z","lookName":"pI-z","shopTheLookContainer":"qI-z","productContainer":"rI-z","imageContainer":"sI-z","mainImage":"tI-z"};